export type ShelfLifeStatus = "active" | "expiringSoon" | "expired" | "unknown";

const EXPIRING_SOON_DAYS = 90;
const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function getShelfLifeStatus(shelfLifeDate: string | null | undefined, now: Date = new Date()): ShelfLifeStatus {
  if (!shelfLifeDate) return "unknown";
  const expiry = new Date(shelfLifeDate);
  if (Number.isNaN(expiry.getTime())) return "unknown";
  const diffDays = Math.floor((expiry.getTime() - now.getTime()) / MS_PER_DAY);
  if (diffDays < 0) return "expired";
  if (diffDays <= EXPIRING_SOON_DAYS) return "expiringSoon";
  return "active";
}
